// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my-body[data-v-2ece53f0]{background:#fff}.text-grey[data-v-2ece53f0]{color:#5c5c5c}.main-text[data-v-2ece53f0]{color:var(--lms-tenant)}.negative-top[data-v-2ece53f0]{margin-top:-.5em}.vueperslides:not(.no-shadow):not(.vueperslides--3d) .vueperslides__parallax-wrapper[data-v-2ece53f0]:after{box-shadow:none!important;box-shadow:none}", ""]);
// Exports
module.exports = exports;
